module.exports = __webpack_public_path__ + "img/review_funnel_template2.e71b0d6b.png";